import {
  AnalyticsEvent,
  AnalyticsEventData,
  AnalyticsEventVerboseData,
  AnalyticsMetaData,
} from '../components/Providers/AnalyticsProvider';
import { API_URL, enrichedFetch } from './api';

export const saveAnalyticsEvent = (
  event: AnalyticsEvent,
  timeStamp: string,
  metadata: AnalyticsMetaData,
  pageLocation: string,
  pageTitle: string,
  data?: AnalyticsEventData,
  verboseData?: AnalyticsEventVerboseData,
  appSessionId?: string
): Promise<void> => {
  return enrichedFetch(`${API_URL}/analytics`, {
    method: 'POST',
    body: JSON.stringify({
      event,
      timeStamp,
      metadata,
      pageLocation,
      pageTitle,
      data,
      verboseData,
      appSessionId,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  }) as Promise<void>;
};
